// extracted by mini-css-extract-plugin
export var footerLegal = "style-module--footerLegal--bfa9e";